import ApiService from "@/core/services/ApiService";

class AccountService {

    public static getSetting(){
        ApiService.setHeader()
        return ApiService.get('api/accounts', 'setting')
    }

    public static getData(params) {
        ApiService.setHeader()
        return ApiService.post('api/accounts',params)
    }

    public static create(params) {
        ApiService.setHeader()
        return ApiService.post('api/accounts/create',params)
    }
}

export default AccountService;